// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2yKbj","inner":"styles_inner__3saSl","right":"styles_right__ZoUMK","close":"styles_close__12cYh","footer":"styles_footer__1xAK8"};